import React from 'react'
import { Link } from 'gatsby'
import { css } from '@emotion/react'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

import Links from './Links'
import Icons from './Icons'

const topRowCss = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 3rem;

  > div:first-of-type {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-bottom: 3rem;

    p {
      font-size: 1.125rem;
      line-height: 1.3;
    }
  }

  ${mediaQueries.smallScreen()} {
    align-items: stretch;
  }

  ${mediaQueries.mediumScreen()} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;

    > div:first-of-type {
      flex-flow: column nowrap;
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
`

const textInfoSectionCss = css`
  p {
    margin: 0;
  }
`

const textLogoCss = css`
  color: inherit;
  margin: 0;
  font-size: 2rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.6rem;

  a {
    color: inherit;
    text-decoration: none;

    &:visited {
      text-decoration: none;
    }

    &:first-of-type {
      letter-spacing: -0.04em;
    }

    &:nth-of-type(2) {
      font-size: 1.2rem;
    }
  }
`

const pipeCss = css`
  font-weight: 500;
  animation-name: blink;
  animation-duration: 0.9s;
  animation-iteration-count: infinite;

  @keyframes blink {
    0% {
      opacity: 100;
    }
    50% {
      opacity: 100;
    }
    51% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
`

const TopRow = () => {
  return (
    <div css={topRowCss}>
      <div css={textInfoSectionCss}>
        <div css={textLogoCss}>
          <a href="https://text.com/">
            text<span css={pipeCss}>&#124;</span>
          </a>
          <Link to="/">Marketplace</Link>
        </div>
        <p>info@text.com</p>
        <Icons />
      </div>
      <Links />
    </div>
  )
}

export default TopRow
